module.exports = __webpack_public_path__ + "img/hr-branch-particle-12.2b4dd18d.png";